export default __webpack_public_path__ + "static/media/msrClose.3e1f4a4c.svg";